import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/auth";
import { I18nProvider } from "@/i18n";
import Login from "@/pages/Login";
import Layout from "@/pages/Layout";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Programs from "@/pages/Programs";
import Bookings from "@/pages/Bookings";
import Settings from "@/pages/Settings";
import Team from "@/pages/Team";
import Suppliers from "@/pages/Suppliers";
import ControlPanel from "@/pages/ControlPanel";
import Reports from "@/pages/Reports";
import Reminders from "@/pages/Reminders";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-sm text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

const AdminOrAccountant = ({ children }) => {
  const { user } = useAuth();
  if (!["admin", "accountant"].includes(user?.role)) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="clients" element={<Clients />} />
              <Route path="programs" element={<Programs />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="suppliers" element={<Suppliers />} />
              <Route path="reports" element={<AdminOrAccountant><Reports /></AdminOrAccountant>} />
              <Route path="reminders" element={<Reminders />} />
              <Route path="team" element={<AdminOnly><Team /></AdminOnly>} />
              <Route path="admin" element={<AdminOnly><ControlPanel /></AdminOnly>} />
              <Route path="settings" element={<AdminOnly><Settings /></AdminOnly>} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
